module.exports = __webpack_public_path__ + "img/product-sample@2x.b96e128b.jpg";